function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import '@babel/polyfill';
import '../biotrust/optin';
import '../biotrust/trackers';
import '../biotrust/vipSessionStorage'; // Remove adaChatBot import until we have time to fix it (EDI-9183)
// import '../biotrust/adaChatBot';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/include/ls.include';
import 'lazysizes/plugins/progressive/ls.progressive';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import '../vendor/slick';
import '../vendor/debut';
import '../vendor/float-panel';
import '../vendor/recharge';
import Player from '@vimeo/player';
import { trackersPush } from '../biotrust/trackers/utils';
import { appendSessionToCart, updateShopifyCart } from '../biotrust/common/hooks/useShopifyCart';
import { getTuneAttributesForShopifyCart } from '../biotrust/trackers/hasoffers';
import { BiotrustProductSection } from '../sections/productsection';
import '../sections/collection';
import '../biotrust/searchanise'; // Debut Theme scripts

import '../../styles/layout/theme.scss';
window.Vimeo = {
  Player: Player
};
$(function () {
  if (!window.theme && !window.theme.sectionsInstance) {
    throw Error('Expected Sections instance to be initialized and set to window.theme.sectionsInstance!');
  }

  console.debug('Registering BiotrustProductSection');
  window.theme.sectionsInstance.register('product', BiotrustProductSection);
  var mainPhone = new RegExp(window.btPhoneSettings.phone, 'g');

  if (window.btPhoneSettings.vipMember === 'true') {
    if ($('.phone').length) {
      $('.phone').html($('.phone').html().replace(mainPhone, window.btPhoneSettings.vipPhone));
    }
  }
});
$( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var tuneAttributes;
  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          trackersPush( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
              var _window$bt, _window$bt$product, _trackers$bt, _trackers$bt2;

              var trackers;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      trackers = _ref2.trackers;
                      _context.next = 3;
                      return appendSessionToCart((_window$bt = window.bt) === null || _window$bt === void 0 ? void 0 : (_window$bt$product = _window$bt.product) === null || _window$bt$product === void 0 ? void 0 : _window$bt$product.inCart, trackers === null || trackers === void 0 ? void 0 : (_trackers$bt = trackers.bt) === null || _trackers$bt === void 0 ? void 0 : _trackers$bt.sessionId, trackers === null || trackers === void 0 ? void 0 : (_trackers$bt2 = trackers.bt) === null || _trackers$bt2 === void 0 ? void 0 : _trackers$bt2.agentId);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }());
          tuneAttributes = getTuneAttributesForShopifyCart();

          if (!tuneAttributes) {
            _context2.next = 5;
            break;
          }

          _context2.next = 5;
          return updateShopifyCart(tuneAttributes);

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));